import platformConfig from '/config/platform.config';
import {
  PERMISSION_ANDROID_WRITE_CONTACTS,
  PERMISSION_GRANTED,
} from '/enum/permission.enum';
import {check, request} from '/util/permission/permission.util';

export const checkAndroidPermissions = async () => {
  if (!(platformConfig.getOS() === 'android')) {
    return true;
  }
  const result = check(PERMISSION_ANDROID_WRITE_CONTACTS);
  // @ts-expect-error TS(2367): This condition will always return 'false' since th... Remove this comment to see the full error message
  if (result === PERMISSION_GRANTED) {
    return true;
  } else {
    const permission = await request(PERMISSION_ANDROID_WRITE_CONTACTS);
    if (permission === PERMISSION_GRANTED) {
      return true;
    }
  }
  return false;
};

interface shapeContactProps {
  lastName: string;
  firstName: string;
  phoneNumber: string;
  accountEmail: string;
}

interface contactFormatedProps {
  familyName: string;
  givenName: string;
  displayName: string;
  phoneNumbers: {label: string; number: string}[];
  emailAddresses: {label: string; email: string}[];
}

export const shapeContact = ({
  lastName = '',
  firstName = '',
  phoneNumber = '',
  accountEmail = '',
}: shapeContactProps): contactFormatedProps => {
  return {
    //ios fields
    familyName: lastName,
    givenName: firstName,
    //android uses displayName field instead
    displayName: firstName + ' ' + lastName,
    phoneNumbers: [
      {
        label: 'mobile',
        number: phoneNumber || '',
      },
    ],
    emailAddresses: [
      {
        label: 'work',
        email: accountEmail || '',
      },
    ],
  };
};
